module.exports = __webpack_public_path__ + "img/pyramid-table.cefbffd3.png";